import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 38px;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 15px;
  color: #026464ff;
`;

export const Input = styled.input`
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: #aaa;
  }
`;

export const AddBtn = styled.button`
  align-self: flex-start;
  padding: 8px 18px;
  background: #005f29ff;
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 6px;
  font-family: "Iosevka Charon", monospace;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: transparent;
    color: #000000;
    border: 1px solid #2e8b57;
  }
`;
